import React from 'react';
import './index.css'
import AnimationContainer from './components/AnimationContainer/index'

function AboutView() {
  return (
    <AnimationContainer />
  );
}

export default AboutView;
